import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  chooseDefaultPay,
  getCards,
  getOwnerBalance,
  getTransactions,
  makePaymentBill,
  payAllServices,
  removePay,
} from '../../api/ans';
import makePayments from '../../api/payments';

export const getCardsThunk = createAsyncThunk(
  'user/getCards',
  async (_, { rejectWithValue }) => {
    try {
      const cards = await getCards();
      return cards;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || 'Не удалось загрузить данные пользователя'
      );
    }
  }
);

export const chooseDefaultPayThunk = createAsyncThunk(
  'user/chooseDefaultPay',
  async (data, { rejectWithValue }) => {
    try {
      const result = await chooseDefaultPay({ id: data });
      return result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || 'Не удалось загрузить данные пользователя'
      );
    }
  }
);

export const removePayThunk = createAsyncThunk(
  'user/removePay',
  async (data, { rejectWithValue }) => {
    try {
      const result = await removePay({ id: data });
      return result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || 'Не удалось загрузить данные пользователя'
      );
    }
  }
);

export const payAllServicesThunk = createAsyncThunk(
  'user/payAllServices',
  async (data, { rejectWithValue }) => {
    try {
      const result = await payAllServices(data); // вызов API без id, т.к. платим все
      return result;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Не удалось оплатить услуги');
    }
  }
);

function sortAndGroup(details) {
  // создаём отсортированную копию
  const sorted = [...details].sort((a, b) => a.doc_no.localeCompare(b.doc_no));

  const result = [];
  let currentDoc = null;

  for (const item of sorted) {
    // если новый doc_no — добавляем "заголовок группы"
    if (item.doc_no !== currentDoc) {
      currentDoc = item.doc_no;
      result.push({ doc_no: currentDoc });
    }

    result.push(item);
  }

  return result;
}

export const getOwnerBalanceThunk = createAsyncThunk(
  'user/getOwnerBalance',
  async (data, { rejectWithValue }) => {
    try {
      const result = await getOwnerBalance({ owner_id: data.toString() }).then(
        (dataServices) => {
          const suppList = sortAndGroup(dataServices?.services?.details);
          console.log(suppList);
          dataServices.services.details = suppList;
          return dataServices;
        }
      );

      return result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || 'Не удалось загрузить данные пользователя'
      );
    }
  }
);

export const payThunk = createAsyncThunk(
  'user/pay',
  async (data, { rejectWithValue }) => {
    try {
      const result = await makePayments(data);
      console.log('✅ result', result);
      return result;
    } catch (err) {
      console.error('❌ Ошибка в thunk', err);
      return rejectWithValue(err.response?.data?.message || 'Ошибка оплаты');
    }
  }
);

export const getBankTransactions = createAsyncThunk(
  'user/getBankTransactions',
  async (data, { rejectWithValue }) => {
    try {
      const result = await getTransactions(data);
      console.log('выполнение запроса для истории платежей', result);
      return result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || 'Не удалось загрузить историю транзакций'
      );
    }
  }
);

export const makePaymentBillThunk = createAsyncThunk(
  'user/makePaymentBillThunk',
  async (data, { rejectWithValue }) => {
    try {
      const result = await makePaymentBill(data);
      console.log('Создать счёт на оплату', result);
      return result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || 'Не удалось оздать счёт на оплату'
      );
    }
  }
);

const initialState = {
  cards: [],
  status: '',
  balance: {},
  bankTransactions: [],
};

const paymentsSlice = createSlice({
  name: 'paymentsMethod',
  initialState,
  reducers: {
    getTrnasactionsHistory(state) {
      return state.bankTransactions;
    },
    getCardsId(state) {
      return state.cards;
    },
    setDefaultCard(state, action) {
      const cardId = action.payload;

      state.cards = state.cards.map((card) => ({
        ...card,
        default: card.id === cardId,
      }));
    },
    removeCard(state, action) {
      const cardId = action.payload;
      state.cards = state.cards.filter((card) => card.id !== cardId);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCardsThunk.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getCardsThunk.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.cards = action.payload.payment_methods;
      })
      .addCase(getCardsThunk.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(chooseDefaultPayThunk.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(chooseDefaultPayThunk.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(chooseDefaultPayThunk.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(getOwnerBalanceThunk.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getOwnerBalanceThunk.fulfilled, (state, action) => {
        state.status = 'succeeded';
        console.log(action.payload);
        state.balance = action.payload;
      })
      .addCase(getOwnerBalanceThunk.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(payAllServicesThunk.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(payAllServicesThunk.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(payAllServicesThunk.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(payThunk.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(payThunk.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(payThunk.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(getBankTransactions.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getBankTransactions.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.bankTransactions = action.payload.bank_transactions;
      })
      .addCase(getBankTransactions.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(makePaymentBillThunk.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(makePaymentBillThunk.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(makePaymentBillThunk.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { getCardsId, setDefaultCard, removeCard } = paymentsSlice.actions;
export default paymentsSlice.reducer;
